// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum DeadLetterTopicActionType {
  Resubmit = "RESUBMIT",
  Discard = "DISCARD",
}

export default DeadLetterTopicActionType;

export function deadLetterTopicActionTypeToVariant(deadLetterTopicActionType: DeadLetterTopicActionType) {
  switch (deadLetterTopicActionType) {
    case DeadLetterTopicActionType.Discard:
      return "danger";

    case DeadLetterTopicActionType.Resubmit:
      return "success";
  }
}
